import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flag, Scale } from "lucide-react";
import { api } from "@/lib/api";
import { formatDate } from "@/lib/constants";

export const FASI_META = {
  indirizzi: ["Indirizzi e preparazione", "bg-slate-100 text-slate-700", "#64748B"],
  perizie: ["Indennizzi e perizie", "bg-amber-50 text-amber-800", "#D97706"],
  gara_indetta: ["Gara indetta", "bg-emerald-50 text-emerald-800", "#059669"],
  valutazione: ["Valutazione", "bg-sky-50 text-sky-800", "#0070BA"],
  aggiudicazione: ["Aggiudicazione", "bg-[#003087] text-white", "#003087"],
};

/** Badge «fase del percorso verso la gara» per la pagina Comune, dai segnali del radar. */
export const FaseComuneBadge = ({ slug }) => {
  const [f, setF] = useState(null);
  useEffect(() => { api.get(`/public/fasi/${slug}`).then((r) => setF(r.data)).catch(() => setF(false)); }, [slug]);
  if (!f || (!f.fase && !f.contenzioso)) return null;
  const m = f.fase ? FASI_META[f.fase] : null;
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2 text-xs" data-testid="comune-fase">
      {m && <Link to="/a-che-punto-sono-i-comuni" className={`inline-flex items-center gap-1 rounded-full px-3 py-1 font-semibold ${m[1]}`} data-testid={`comune-fase-${f.fase}`}><Flag size={12} /> Fase: {m[0]}</Link>}
      {f.contenzioso && <span className="inline-flex items-center gap-1 rounded-full bg-red-50 text-red-700 px-3 py-1 font-semibold" data-testid="comune-fase-contenzioso"><Scale size={12} /> Contenzioso in corso</span>}
      {f.ultimo && <span className="text-slate-600 dark:text-slate-300">ultimo segnale: {f.ultimo.titolo?.slice(0, 90)}{f.ultimo.data ? ` · ${formatDate(f.ultimo.data)}` : ""}</span>}
    </div>
  );
};
